import { Popover } from "@mui/material";
import classNames from "classnames";
import { Link } from "react-router";

import { useAuth } from "@/providers";
import { RobotoDivider, RobotoTypography } from "@/shared/components";
import {
  UserPlus,
  ChevronRight,
  LogOut,
  EntityIcon,
} from "@/shared/foundation/icons";
import { usePopupState } from "@/shared/hooks";
import { Goto } from "@/shared/navigation/Goto";

import { OrgSelectionMenu } from "./OrgSelectionMenu";
import styles from "./OrgSettingsMenu.module.css";

interface OrgSettingsMenuProps {
  anchorEl: HTMLElement | null;
  handleClose: () => void;
}

export function OrgSettingsMenu(props: OrgSettingsMenuProps) {
  const popup = usePopupState();
  const { signOut } = useAuth();

  return (
    <Popover
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={props.handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: -5,
        horizontal: -5,
      }}
      marginThreshold={5}
    >
      <ul className={styles.menuList}>
        <li className={styles.menuItem}>
          <Link to={Goto.route.Account} onClick={props.handleClose}>
            <EntityIcon type="user" className={styles.icon} />
            <RobotoTypography fontWeight={500} variant="body2">
              Account settings
            </RobotoTypography>
          </Link>
        </li>

        <RobotoDivider className={styles.divider} />

        <li className={styles.menuItem}>
          <Link
            to={Goto.route.Settings.Organization}
            onClick={props.handleClose}
          >
            <UserPlus className={styles.icon} />
            <RobotoTypography fontWeight={500} variant="body2">
              Invite members
            </RobotoTypography>
          </Link>
        </li>

        <RobotoDivider className={styles.divider} />

        <li
          className={classNames(styles.menuItem, {
            [styles.active]: popup.isOpen,
          })}
        >
          <button
            onClick={(event) =>
              popup.open({
                anchorEl: event.currentTarget,
              })
            }
          >
            <EntityIcon type="org" className={styles.icon} />
            <RobotoTypography fontWeight={500} variant="body2">
              Switch organization
            </RobotoTypography>
            <ChevronRight className={styles.rightArrow} />
          </button>
          <OrgSelectionMenu
            anchorEl={popup.anchor}
            handleClose={() => {
              popup.close();
              props.handleClose();
            }}
          />
        </li>

        <li className={styles.menuItem}>
          <button
            onClick={() => {
              void signOut();
              props.handleClose();
            }}
          >
            <LogOut className={styles.icon} />
            <RobotoTypography fontWeight={500} variant="body2">
              Logout
            </RobotoTypography>
          </button>
        </li>
      </ul>
    </Popover>
  );
}
